import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LeasecommitmentserviceService } from './leasecommitmentservice.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-operating-lease-commitments',
  templateUrl: './operating-lease-commitments.component.html',
  styleUrls: ['./operating-lease-commitments.component.scss']
})
export class OperatingLeaseCommitmentsComponent implements OnInit {
  constructor(private formbuilder: FormBuilder, private commitservice: LeasecommitmentserviceService, public commonService: CommonService, private router: Router, public sidenav: SideNavService) { }
  commitmentform: FormGroup;
  APPeriodId: any; isJump: any;
  commitId: any;
  total: any;
  total_ly: any;
  NormalRoutng: boolean;
  showBubbledata:any

  ngOnInit() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders;
    this.createleasecommitments()
    this.getleasecommitments(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata();
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})
      this.clearfield();
    if (localStorage.getItem("SubmitStatus") == "true")
      this.commitmentform.disable()
  }

  createleasecommitments() {
    this.commitmentform = this.formbuilder.group({
      APPeriodId: ['', []],
      Operatingleasecommitments_ID: ['', []],
      MasterId: ['', []],
      OperatingLeasesExpiringWithinOneYear: ['', []],
      OperatingLeasesExpiringWithinOneYear_LY: ['', []],
      OperatingLeasesExpiringBetweenTwoFiveYears: ['', []],
      OperatingLeasesExpiringBetweenTwoFiveYears_LY: ['', []],
      OperatingLeasesExpiringAfterFiveYears: ['', []],
      OperatingLeasesExpiringAfterFiveYears_LY: ['', []],
      OperatingLeases: new FormControl({ value: null, disabled: true }),
      OperatingLeases_LY: new FormControl({ value: null, disabled: true }),
      AndicaOpreatingLease: ['', []],
      CreatedBy: ['', []],
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.commitmentform.reset()
      }
    })
  }

  Insertcommitments() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commitmentform.controls['APPeriodId'].setValue(this.APPeriodId)
    this.commitmentform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.commitmentform.getRawValue();
    if (this.commitId) {
      this.commitmentform.controls['Operatingleasecommitments_ID'].setValue(this.commitId)
    }
    this.commitservice.insertlease(formdata).subscribe((data) => {
      this.commitmentform.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Operating lease commitments", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'operatingleasecommitments') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }

  getleasecommitments(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commitservice.getleasecommit(this.APPeriodId).subscribe((data: any) => {
      if (data) {
        this.commitmentform.patchValue(data);
        this.commitId = data.Operatingleasecommitments_ID
      }
      this.commonService.getNotesData();
    })
  }
  getlastyeardata() {
    this.commitservice.getleasecommitLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }

  back() {
    this.commitmentform.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Operating lease commitments", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  save() {
    debugger
    this.Insertcommitments()
  }

  Commitmentscal() {
    debugger;
    this.total = 0;
    this.total = parseFloat(((this.commitmentform.controls['OperatingLeasesExpiringWithinOneYear'].value == "" || this.commitmentform.controls['OperatingLeasesExpiringWithinOneYear'].value == null) ? 0 : this.commitmentform.controls['OperatingLeasesExpiringWithinOneYear'].value))
      + parseFloat(((this.commitmentform.controls['OperatingLeasesExpiringBetweenTwoFiveYears'].value == "" || this.commitmentform.controls['OperatingLeasesExpiringBetweenTwoFiveYears'].value == null) ? 0 : this.commitmentform.controls['OperatingLeasesExpiringBetweenTwoFiveYears'].value))
      + parseFloat(((this.commitmentform.controls['OperatingLeasesExpiringAfterFiveYears'].value == "" || this.commitmentform.controls['OperatingLeasesExpiringAfterFiveYears'].value == null) ? 0 : this.commitmentform.controls['OperatingLeasesExpiringAfterFiveYears'].value))

    this.commitmentform.controls["OperatingLeases"].setValue(this.total);
  }

  Commitmentlastyearcal() {
    debugger;
    this.total_ly = 0;
    this.total_ly = parseFloat(((this.commitmentform.controls['OperatingLeasesExpiringWithinOneYear_LY'].value == "" || this.commitmentform.controls['OperatingLeasesExpiringWithinOneYear_LY'].value == null) ? 0 : this.commitmentform.controls['OperatingLeasesExpiringWithinOneYear_LY'].value))
      + parseFloat(((this.commitmentform.controls['OperatingLeasesExpiringBetweenTwoFiveYears_LY'].value == "" || this.commitmentform.controls['OperatingLeasesExpiringBetweenTwoFiveYears_LY'].value == null) ? 0 : this.commitmentform.controls['OperatingLeasesExpiringBetweenTwoFiveYears_LY'].value))
      + parseFloat(((this.commitmentform.controls['OperatingLeasesExpiringAfterFiveYears_LY'].value == "" || this.commitmentform.controls['OperatingLeasesExpiringAfterFiveYears_LY'].value == null) ? 0 : this.commitmentform.controls['OperatingLeasesExpiringAfterFiveYears_LY'].value))

    this.commitmentform.controls["OperatingLeases_LY"].setValue(this.total_ly);
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.commitmentform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.save();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
